import noop from 'lodash/noop';
// eslint-disable-next-line no-restricted-imports
import { createActions } from 'redux-actions';

/**
 * The action type names in this file cannot change as they are used in the
 * desktop app
 */
export const jabraActions = createActions(
  {
    JABRA_LIST: [
      (payload) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    JABRA_RING: [
      (payload) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    JABRA_UNRING: [
      (payload) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    JABRA_INIT: [
      (payload) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
  },

  'JABRA_INIT_SUCCEEDED',

  'JABRA_ATTACHED',
  'JABRA_DETACHED',

  'JABRA_RING_SUCCEEDED',
  'JABRA_RING_FAILED',

  'JABRA_UNRING_SUCCEEDED',
  'JABRA_UNRING_FAILED',

  'JABRA_LIST_SUCCEEDED',
  'JABRA_LIST_FAILED',

  'JABRA_CLOSED',

  'JABRA_BUTTON_CLICKED',
  'JABRA_BUTTON_CLICKED_ACCEPTED_CALL_OFFER_CONVERSATION',
  'JABRA_BUTTON_CLICKED_REJECTED_CALL_OFFER_CONVERSATION',
  'JABRA_BUTTON_CLICKED_UNSUPPORTED',

  'JABRA_REQUEST_DEVICE',
  'JABRA_CALL_ACCEPTED',
  'JABRA_CALL_REJECTED',
);
